@use "ui/styles/fontStyles";
@use "ui/styles/sizes";
@use "ui/styles/colors";

.tree {
  display: flex;
  flex-direction: column;
  margin-top: 0;

  > .treeContainer:first-child > .row {
    padding-top: sizes.$s2;
  }
}

.treeContainer {
  display: flex;
  flex-direction: column;
}

.row {
  display: flex;
  padding-top: sizes.$s4;
  align-items: center;
  gap: sizes.$s4;
}

.bullet {
  @include fontStyles.body3-medium;
  color: colors.$black;
}

.label {
  @include fontStyles.body3-medium;
  color: colors.$black;
}

.ancestor {
  .bullet,
  .label {
    color: colors.$gray50;
  }
}

.descriptor {
  @include fontStyles.body3-medium;
  color: colors.$gray60;
}

.children {
  margin-left: 22px;
}

.indented {
  margin-left: 22px;
}
